import { Stack, type StackProps, useTheme } from "@mui/material";
import { Globe2, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import type { FC } from "react";
import { AdvisorContactLine } from "web_myplann/Advisor/Components/AdvisorContactLine";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getExternalUrl } from "web_myplann/Shared/Utils/getExternalUrl";
import { getMapsLink } from "web_myplann/Utils/getMapsLink";

const R = Resources.Advisor;

type Props = Omit<StackProps, "children"> & {
	phone?: string;
	email?: string;
	address?: string;
	linkedin?: string;
	website?: string;
};

export const AdvisorContactLines: FC<Props> = ({
	phone,
	email,
	address,
	linkedin,
	website,
	...stackProps
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			gap={theme.spacingTokens.sm}
			alignItems="center"
			width="100%"
			{...stackProps}
		>
			{phone && <AdvisorContactLine icon={Phone} text={phone} />}
			{email && (
				<AdvisorContactLine
					icon={Mail}
					text={email}
					href={`mailto:${email}`}
					ariaLabel={t(R.emailAria, { email })}
				/>
			)}
			{address && (
				<AdvisorContactLine
					icon={MapPin}
					text={address}
					href={getMapsLink(address)}
					ariaLabel={t(R.addressAria, { address })}
				/>
			)}
			{linkedin && (
				<AdvisorContactLine
					icon={Linkedin}
					text={linkedin}
					href={getExternalUrl(linkedin)}
					ariaLabel={t(R.linkedinAria)}
				/>
			)}
			{website && (
				<AdvisorContactLine
					icon={Globe2}
					text={website}
					href={getExternalUrl(website)}
					ariaLabel={t(R.websiteAria)}
				/>
			)}
		</Stack>
	);
};
